import * as Immutable from "immutable";
import VisualizationConfig from "./VisualizationConfig";
export default class NumberVisualizationConfig extends VisualizationConfig {
  constructor(trend, trendPreference) {
    super();
    this._value = { trend, trendPreference };
  }
  get trend() {
    return this._value.trend;
  }
  get trendPreference() {
    return this._value.trendPreference;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(trend = false, lowerIsBetter = "NEUTRAL") {
    return new NumberVisualizationConfig(trend, lowerIsBetter);
  }
  static empty() {
    return NumberVisualizationConfig.create(false, "NEUTRAL");
  }
  toJSON() {
    const { trend, trendPreference } = this._value;
    return {
      trend,
      trend_preference: trendPreference
    };
  }
  equalsForSearch(other) {
    return other && "trend" in other && other.trend === this.trend;
  }
  static fromJSON(_type, value) {
    const { trend, trend_preference: trendPreference } = value;
    return NumberVisualizationConfig.create(trend, trendPreference);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  trend(value) {
    return new Builder(this.value.set("trend", value));
  }
  trendPreference(value) {
    return new Builder(this.value.set("trendPreference", value));
  }
  build() {
    const { trend, trendPreference } = this.value.toObject();
    return new NumberVisualizationConfig(trend, trendPreference);
  }
}
